<ax-text-box  [placeholder]="placeholder"></ax-text-box>